export enum CoachingTypesEnum {
  SemiPrivateCoaching = "SPC",
  OneToOneCoaching = "OTOC",
  NoCoaching = "na",
}
